<img *ngIf="!!displayedSrc" 
    class="cwt-media-node cwt-media-node-{{state}}"
    [src]="displayedSrc"
    (load)="onMediaLoaded()"
    (error)="onMediaError()">

<ng-container *cwtMediaAddonOutlet="addons; state: state"></ng-container>